export const HOME = "/home/:country";
export const HOME_BASE = "/home";
export const HOME_REDIRECT = "/home/Global"
export const SIGN_IN = "/signin";
export const SIGN_UP = "/signup";
export const PASSWORD_FORGET = "/pw-forget";
export const YOUR_NEWS = "/your-news";
export const NEWS = "/news/:id";
export const NEWS_BASE = "/news";
export const CREATE_NEWS = "/create-news";
export const MODIFY_NEWS = "/modify-news/:id";
export const MODIFY_NEWS_BASE = "/modify-news";
